import {
  PrimaryButton,
  DetailsList,
  ShimmeredDetailsList,
  Label,
  Stack,
  StackItem,
  DetailsListLayoutMode,
  IColumn,
  IIconProps,
  TextField,
  Dropdown,
  IDropdownOption,
  IDropdownStyles,
  ITextFieldStyles,
  IconButton,
  SelectionMode,
  Modal,
  mergeStyleSets,
  NormalPeoplePicker,
  IPersonaProps,
  ChoiceGroup,
  IChoiceGroupOption,
  mergeStyles,
  Persona,
  PersonaSize,
  Checkbox,
  MessageBar,
  MessageBarType,
  ITooltipHostStyles,
  TooltipHost,
  ILabelStyles,
  DefaultButton,
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import styles from "./newProject.module.scss";
import { IRecipientsManagement } from "../../../common/models/IRecipientsManagement";
import ProjectService from "../../../common/api-services/ProjectServices";
import GraphService from "../../../common/authProvider/GraphService";
import { IProject } from "../../../common/models/IProject";
import CommonService from "../../../common/api-services/CommonService";
import { ICommon } from "../../../common/models/ICommon";
import { IAzureUserInformation } from "../../../common/models/IUserDetails";
import { IReportDocument } from "../../../common/models/IReportDocument";
import { ICoordinator } from "../../../common/models/ICoordinator";

export const categories: IDropdownOption[] = [
  {
    key: "CDD",
    text: "Commercial Due Diligence",
  },
  {
    key: "VCDD",
    text: "Vendor Commercial Due Diligence",
  },
  {
    key: "ODD",
    text: "Operational Due Diligence",
  },
  {
    key: "DD",
    text: "Due Diligence",
  },
  {
    key: "MS",
    text: "Market study",
  },
];

const NewProject = () => {
  const calloutProps = { gapSpace: 0 };

  const hostStyles: Partial<ITooltipHostStyles> = {
    root: { display: "inline-block" },
  };
  const contentStyles = mergeStyleSets({
    container: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      border: "1px solid",
      minHeight: "400px",
      minWidth: "600px",
      borderRadius: "25px",
    },
    archiveContainer: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "stretch",
      border: "1px solid",
      minHeight: "120px",
      minWidth: "250px",
      borderRadius: "25px",
    },
  });

  const service = useMemo(() => new ProjectService(), []);
  const graphService = useMemo(() => new GraphService(), []);
  const { projectId = "" } = useParams();
  const [project, setProject] = useState<any>({
    status: "Draft",
    documents: [],
  });
  const [currentUser, setCurrentUser] = useState<IAzureUserInformation>();
  const [selectedCompany, setSelectedCompany] = useState("");
  const [itemsAccessManagement, setItemsAccessManagement] = useState<any[]>([]);
  const [editPermission, isEditPermission] = useState<boolean>(false);
  const [deletePermission, isDeletePermission] = useState<boolean>(false);
  const [sentReport] = useState<boolean>(false);
  const [sentTac, isSentTac] = useState<boolean>(false);
  const [recipientItem, setRecipientItem] = useState<any>();
  const [deletePermissionItem, setDeletePermissionItem] = useState<any>();
  const [deleteRecipient, isDeleteRecipient] = useState<boolean>(false);
  const [deleteCoordinator, isDeleteCoordinator] = useState<boolean>(false);
  const [deleteRecipientItem, setDeleteRecipientItem] = useState<any>();
  const [deleteCoordinatorItem, setDeleteCoordinatorItem] = useState<any>();
  const [showPanel, isShowPanel] = useState<boolean>(false);
  const [showSaveBtn, isShowSaveBtn] = useState<boolean>(false);
  const [numberSelectedRecipients, setNumberSelectedRecipients] =
    useState<number>(0);
  const [indeterminateAutoTAC, isIndeterminateAutoTAC] =
    useState<boolean>(false);
  const [checkedTAC, isCheckedTAC] = useState<boolean>(true);
  const [selectAllcheckBoxTAC, isSelectAllcheckBoxTAC] =
    useState<boolean>(false);
  const [, isIndeterminateAutoReport] = useState<boolean>(false);
  const [checkedReport, isCheckedReport] = useState<boolean>(false);
  const [, isDisableAllCheckboxReport] = useState<boolean>(false);
  const [selectAllcheckBoxReport, isSelectAllcheckBoxReport] =
    useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [messageBarType, setMessageBarType] = useState<MessageBarType>();
  const [messageRecipient, setMessageRecipient] = useState<string>("");
  const [messageReportDistribution, setMessageReportDistribution] =
    useState<string>("");
  const [messageBarTypeRecipient, setMessageBarTypeRecipient] =
    useState<MessageBarType>();
  const [
    messageBarTypeReportDistribution,
    setMessageBarTypeReportDistribution,
  ] = useState<MessageBarType>();
  const [messagePermission, setMessagePermission] = useState<string>("");
  const [messageBarTypePermission, setMessageBarTypePermission] =
    useState<MessageBarType>();
  const [messageReport, setMessageReport] = useState<string>("");
  const [messageBarTypeReport, setMessageBarTypeReport] =
    useState<MessageBarType>();
  const [errorMessageFieldRequired, setErrorMessageFieldRequired] =
    useState<string>("");

  const [itemsAccessManagementModal, setItemsAccessManagementModal] = useState<
    any[]
  >([]);

  const [currentSelectedMembers, setCurrentSelectedMembers] = React.useState<
    any[]
  >([]);
  const [
    isModalSendTacOrReportOpen,
    { setTrue: showModalSendTacOrReport, setFalse: hideModalSendTacOrReport },
  ] = useBoolean(false);
  const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] =
    useBoolean(false);
  const [
    isModalArchiveOpen,
    { setTrue: showArchiveModal, setFalse: hideArchiveModal },
  ] = useBoolean(false);
  const [
    isModalReactivateOpen,
    { setTrue: showReactivateModal, setFalse: hideReactivateModal },
  ] = useBoolean(false);
  const [
    isModalRecipientOpen,
    { setTrue: showRecipientModal, setFalse: hideRecipientModal },
  ] = useBoolean(false);
  const [
    isModalReportDistributionOpen,
    {
      setTrue: showReportDistributionModal,
      setFalse: hideReportDistributionModal,
    },
  ] = useBoolean(false);
  const [itemsRecipientsManagement, setItemsRecipientsManagement] = useState<
    IRecipientsManagement[]
  >([]);
  const [itemsReportDistribution, setItemsReportDistribution] = useState<
    ICoordinator[]
  >([]);
  // Shimmer the project's data tables while the project is being fetched (edit mode).
  // For a brand-new project there is nothing to fetch, so start disabled.
  const [
    isLoadingProject,
    { setTrue: startLoadingProject, setFalse: stopLoadingProject },
  ] = useBoolean(!!projectId);
  const [reportDocumentManagement, setReportDocumentManagement] = useState<
    IReportDocument[]
  >([]);
  const [errorMessageEmail, setErrorMessageEmail] = useState<string>("");
  const [errorMessageCoordinatorEmail, setErrorMessageCoordinatorEmail] =
    useState<string>("");
  const [recipientEmail, setRecipientEmail] = useState<string>("");
  const [coordinatorEmail, setCoordinatorEmail] = useState<string>("");
  const [coordinatorName, setCoordinatorName] = useState<string>("");
  const [coordinatorSurname, setCoordinatorSurname] = useState<string>("");
  const [coordinatorCompanyName, setCoordinatorCompanyName] =
    useState<string>("");
  const [recipientManagementModal, setRecipientManagementModal] = useState<
    IRecipientsManagement[]
  >([]);
  const [reportDistributionModal, setReportDistributionModal] = useState<
    ICoordinator[]
  >([]);
  const [
    isModalProcessOpen,
    { setTrue: showProcessModal, setFalse: hideProcessModal },
  ] = useBoolean(false);
  const serviceCommon = useMemo(() => new CommonService(), []);
  const [companies, setCompanies] = useState<IDropdownOption[]>([]);
  const [ownersCount, setOwnersCount] = useState<number>(0);
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/home`;
    navigate(path);
  };

  const onDropDownChange = (
    event: React.FormEvent<HTMLDivElement>,
    field: string,
    option?: IDropdownOption,
  ): void => {
    let obj: any = project ? project : {};
    obj[field] = option?.key;
    setProject({ ...obj });
    if (field == "company") {
      setSelectedCompany(obj.company);
    }
  };
  const onChangeTxtField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string,
    newValue?: string,
  ): void => {
    if (field === "email") {
      setRecipientEmail(newValue ? newValue : "");
    } else if (field === "coordinatorEmail") {
      setCoordinatorEmail(newValue ? newValue : "");
    } else if (field === "coordinatorName") {
      setCoordinatorName(newValue ? newValue : "");
    } else if (field === "coordinatorSurname") {
      setCoordinatorSurname(newValue ? newValue : "");
    } else if (field === "coordinatorCompanyName") {
      setCoordinatorCompanyName(newValue ? newValue : "");
    } else {
      let obj: any = project ? project : {};
      obj[field] = newValue;
      setProject({ ...obj });
    }
  };
  const onSubmitProject = () => {
    if (
      project.name &&
      project.category &&
      project.client &&
      project.target &&
      project.company
    ) {
      setErrorMessageFieldRequired("");
      if (projectId != "") {
        service.Update(project).then((result: any) => {
          if (result?.error) {
            setMessage(`Error: ${result?.error}`);
            setMessageBarType(MessageBarType.error);
          } else {
            setProject(project);
            setMessage(`${project.name} updated successfully`);
            setMessageBarType(MessageBarType.success);
          }
          setTimeout(resetMessage, 10000);
        });
      } else {
        service
          .Create({
            ...project,
            owner: currentUser?.email + ";",
            bcc: currentUser?.email ? [currentUser.email] : [],
            contributor: "",
            isDeleted: false,
            bccRecipientManagement: true,
            bccDistributionManagement: true,
          })
          .then((result: any) => {
            if (result?.error) {
              setMessage(`Error: ${result?.error}`);
              setMessageBarType(MessageBarType.error);
            } else {
              setProject(result);
              navigate(`/project/${result.projectId}`);
              setMessage(`${result.name} created successfully`);
              setMessageBarType(MessageBarType.success);
            }
            setTimeout(resetMessage, 10000);
          });
      }
    } else {
      setErrorMessageFieldRequired("Field is required");
    }
  };
  const onAddProjectPermission = () => {
    let usersToSend = itemsAccessManagementModal;
    const newEmails = itemsAccessManagementModal
      .map((item) => item.mail)
      .filter((x) => !!x);
    itemsAccessManagement.forEach((element) => {
      if (
        itemsAccessManagementModal.filter((e) => e.mail == element.mail)
          .length == 0
      ) {
        usersToSend.push(element);
      }
    });
    let owners = usersToSend
      .map((item) => {
        return item.projectRole == "Owner" ? item.mail : "";
      })
      .filter((n) => n)
      .join(";");

    let contributors = usersToSend
      .map((item) => {
        return item.projectRole == "Member" ? item.mail : "";
      })
      .filter((n) => n) //remove empty entries
      .join(";"); // join email adresses

    let bccList = project.bcc ? project.bcc : [];
    if (!editPermission) {
      bccList = [...bccList, ...newEmails];
    }

    let obj = {
      ...project,
      contributor: contributors,
      owner: owners,
      bcc: bccList,
    };
    setProject(obj);
    hideModal();
    setItemsAccessManagementModal([]);
    service.Update(obj as IProject).then((data: any) => {
      if (data?.error) {
        setMessagePermission(`Error: ${data?.error}`);
        setMessageBarTypePermission(MessageBarType.error);
      } else {
        setItemsAccessManagement(usersToSend);
        let currentSelectedUsers: IPersonaProps[] = [];
        usersToSend.forEach((element: { [x: string]: any }) => {
          let option = {
            key: element["mail"] || 0,
            text: element["displayName"] || "",
          };
          currentSelectedUsers.push(option);
        });
        setCurrentSelectedMembers(currentSelectedUsers);
        if (editPermission) {
          setMessagePermission(`User rights updated successfully`);
        } else {
          setMessagePermission(`Project member/owner added successfully`);
        }

        setMessageBarTypePermission(MessageBarType.success);
      }
      setTimeout(resetMessagePermission, 10000);
    });
  };
  const onDeleteProjectUserPermission = (item: any) => {
    let obj = project;
    //Owner
    if (item.projectRole === options[0].key) {
      //Check if there it at least one owner. todo
      let bccList = obj.bcc ? obj.bcc : [];
      if (bccList.includes(item.mail)) {
        bccList = bccList.filter((email: string) => email !== item.mail);
      }
      obj = { ...obj, bcc: bccList, owner: obj.owner.replace(item.mail, "") };
      setProject(obj);
      resetModal();
      service
        .DeleteUserPermission(obj as IProject, item.mail)
        .then((data: any) => {
          if (data?.error) {
            setMessagePermission(`Error: ${data?.error}`);
            setMessageBarTypePermission(MessageBarType.error);
          } else {
            setMessagePermission(`Project member/owner deleted successfully`);
            setMessageBarTypePermission(MessageBarType.success);
          }

          setTimeout(resetMessagePermission, 10000);
        });
    } else {
      let bccList = obj.bcc ? obj.bcc : [];
      if (bccList.includes(item.mail)) {
        bccList = bccList.filter((email: string) => email !== item.mail);
      }
      obj = {
        ...obj,
        contributor: obj.contributor.replace(item.mail, ""),
        bcc: bccList,
      };
      setProject(obj);
      service
        .DeleteUserPermission(obj as IProject, item.mail)
        .then((data: any) => {
          if (data?.error) {
            setMessagePermission(`Error: ${data?.error}`);
            setMessageBarTypePermission(MessageBarType.error);
          } else {
            setMessagePermission(`Project member/owner deleted successfully`);
            setMessageBarTypePermission(MessageBarType.success);
          }
          resetModal();
          setTimeout(resetMessagePermission, 10000);
        });
    }
  };
  const onStartProcess = () => {
    let obj = project as IProject;
    obj.status = "Active";
    service.StartProcess(obj as IProject).then((data: any) => {
      if (data?.error) {
        setMessage(`Error: ${data?.error}`);
        setMessageBarType(MessageBarType.error);
      } else {
        getProject();
        setMessage(`Process started successfully`);
        setMessageBarType(MessageBarType.success);
      }
      setTimeout(resetMessage, 10000);
      hideProcessModal();
    });
  };
  const _onFormatDate = (date: string): string => {
    const myDate = new Date(date);
    return (
      ("0" + myDate.getDate()).slice(-2) +
      "." +
      ("0" + (myDate.getMonth() + 1)).slice(-2) +
      "." +
      myDate.getFullYear() +
      ", " +
      ("0" + myDate.getHours()).slice(-2) +
      ":" +
      ("0" + myDate.getMinutes()).slice(-2)
    );
  };
  function listContainsPersona(
    persona: IPersonaProps,
    personas: IPersonaProps[],
  ) {
    if (!personas || !personas.length || personas.length === 0) {
      return false;
    }
    return personas.filter((item) => item.text === persona.text).length > 0;
  }
  function removeDuplicates(
    personas: IPersonaProps[],
    possibleDupes: IPersonaProps[],
  ) {
    return personas.filter(
      (persona) => !listContainsPersona(persona, possibleDupes),
    );
  }
  const filterPersonasByText = async (
    filterText: string,
  ): Promise<IPersonaProps[]> => {
    let usersL: any = await graphService.getUsersByName(filterText);
    let peoples: IPersonaProps[] = [];
    usersL.value.forEach((element: { [x: string]: any }) => {
      let option = {
        key: element["mail"] || 0,
        text: element["displayName"] || "",
      };
      peoples.push(option);
    });
    return peoples;
  };
  const filterPromise = (
    personasToReturn: IPersonaProps[],
  ): IPersonaProps[] | Promise<IPersonaProps[]> => {
    return personasToReturn;
  };
  const onItemsChange = async (items?: any[]): Promise<void> => {
    let result: IPersonaProps[] = [];
    let accessItems: any[] = [];
    if (items) {
      let allUsers = await graphService.getUserBatch(
        items.map((u) => {
          return u.key;
        }),
      );
      items.forEach((element) => {
        let temp = allUsers.filter((item: { mail: string }) => {
          return (item.mail as string) == element.key;
        });
        result.push(temp[0]);
        let accessItem = itemsAccessManagementModal.filter((item: any) => {
          return item.mail == temp[0].mail;
        });
        if (accessItem.length == 0) {
          accessItem = { ...temp[0], projectRole: "Member" };
          accessItems.push(accessItem);
        } else {
          accessItems.push(accessItem[0]);
        }
      });
      setItemsAccessManagementModal(accessItems);
    }
  };
  const onFilterChanged = async (
    filterText: string,
    currentPersonas?: IPersonaProps[],
    limitResults?: number,
  ): Promise<IPersonaProps[]> => {
    if (filterText) {
      let filteredPersonas: IPersonaProps[] =
        await filterPersonasByText(filterText);
      currentPersonas = currentSelectedMembers;
      filteredPersonas = removeDuplicates(
        filteredPersonas,
        currentPersonas ?? [],
      );
      filteredPersonas = limitResults
        ? filteredPersonas.slice(0, limitResults)
        : filteredPersonas;
      return filterPromise(filteredPersonas);
    } else {
      return [];
    }
  };
  const options: IChoiceGroupOption[] = [
    { key: "Owner", text: "Owner", styles: { field: { marginBottom: 5 } } },
    {
      key: "Member",
      text: "Member",
      styles: { field: { marginLeft: "15px", marginBottom: 5 } },
      // disabled: ownersCount == 1,
    },
  ];
  const _onChangeMemberPermission = (
    item: any,
    option?: IChoiceGroupOption,
  ) => {
    let result: any[] = [];
    itemsAccessManagementModal.forEach((element) => {
      if (item.mail == element.mail) {
        element = { ...element, projectRole: option?.key };
        result.push(element);
      } else {
        result.push(element);
      }
    });
    setItemsAccessManagementModal(result);
  };

  const columnStyle = mergeStyles({
    alignSelf: "center",
  });

  const columnsAccessManagement: IColumn[] = [
    {
      key: "column1",
      name: "E-mail",
      fieldName: "mail",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column1",
      name: "First name",
      fieldName: "givenName",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column1",
      name: "Last name",
      fieldName: "surname",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column3",
      name: "Position",
      fieldName: "jobTitle",
      minWidth: 200,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
      isPadded: false,
    },
    {
      key: "column4",
      name: "Platform",
      fieldName: "department",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
      isPadded: false,
    },
    {
      key: "column5",
      name: "Project role",
      fieldName: "projectRole",
      minWidth: 80,
      maxWidth: 150,
      isRowHeader: true,

      data: "string",
      isPadded: false,
    },
    {
      key: "column9",
      name: "BCC'ed",
      fieldName: "",
      minWidth: 50,
      maxWidth: 50,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="center" style={{ paddingTop: 3 }}>
            <TooltipHost
              content="BCC'ed on e-mails sent by Electronic Release Letter Platform"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <Checkbox
                checked={project.bcc?.includes(item?.mail)}
                disabled={
                  !(
                    projectId != "" &&
                    (project.owner?.includes(currentUser?.email) ||
                      project.contributor?.includes(currentUser?.email))
                  )
                }
                styles={{ root: { marginLeft: -1 } }}
                onChange={(ev, checked) => {
                  // onChangeCheckBox(item, "tac", ev, checked);
                  onChangeBcc(item?.mail, checked);
                }}
              />
            </TooltipHost>
          </Stack>
        );
      },
    },
    {
      key: "column8",
      name: "",
      fieldName: "",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <>
            {
              <Stack horizontal horizontalAlign="end">
                {!(ownersCount == 1 && item.projectRole == "Owner") &&
                  project.owner?.includes(currentUser?.email) &&
                  project.status != "Archived" && (
                    <TooltipHost
                      content="Edit user rights"
                      calloutProps={calloutProps}
                      styles={hostStyles}
                    >
                      <IconButton
                        iconProps={{ iconName: "Edit" }}
                        className={styles.actionIconButton}
                        onClick={() => {
                          isEditPermission(true);
                          setItemsAccessManagementModal([item]);
                          showModal();
                        }}
                      />
                    </TooltipHost>
                  )}
                {((!(ownersCount == 1 && item.projectRole == "Owner") &&
                  project.owner?.includes(currentUser?.email)) ||
                  (currentUser?.email == item.mail &&
                    item.projectRole != "Owner")) &&
                  project.status != "Archived" && (
                    <TooltipHost
                      content="Delete user"
                      calloutProps={calloutProps}
                      styles={hostStyles}
                    >
                      <IconButton
                        iconProps={{ iconName: "Delete" }}
                        className={styles.actionIconButton}
                        onClick={() => {
                          setDeletePermissionItem(item);
                          isDeletePermission(true);
                          showModal();
                        }}
                      />
                    </TooltipHost>
                  )}
              </Stack>
            }
          </>
        );
      },
    },
  ];
  const columnsAccessManagementModal: IColumn[] = [
    {
      key: "column1",
      name: "",
      fieldName: "text",
      minWidth: 100,
      maxWidth: 150,
      className: columnStyle,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="start">
            <Persona
              text={item.displayName}
              secondaryText={item.jobTitle}
              size={PersonaSize.size32}
            />
          </Stack>
        );
      },
    },
    {
      key: "column5",
      name: "Project role",
      fieldName: "projectRole",
      minWidth: 80,
      maxWidth: 150,
      isRowHeader: true,

      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="start">
            <ChoiceGroup
              options={options}
              styles={{ flexContainer: { display: "flex" } }}
              defaultSelectedKey={editPermission ? item.projectRole : "Member"}
              onChange={(ev, option) => {
                _onChangeMemberPermission(item, option);
              }}
            ></ChoiceGroup>
          </Stack>
        );
      },
    },
  ];
  const columnsReportDistributionManagement: IColumn[] = [
    {
      key: "column1",
      name: "E-mail",
      fieldName: "email",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column2",
      name: "First name",
      fieldName: "name",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column3",
      name: "Last name",
      fieldName: "surname",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column4",
      name: "Company",
      fieldName: "companyName",
      minWidth: 80,
      maxWidth: 300,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column5",
      name: "",
      fieldName: "id",
      minWidth: 40,
      maxWidth: 40,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="end">
            <TooltipHost
              content="Delete coordinator"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              {project.status != "Archived" &&
                project?.coordinators?.length > 1 &&
                (project.owner?.includes(currentUser?.email) ||
                  project.contributor?.includes(currentUser?.email)) && (
                  <IconButton
                    iconProps={{ iconName: "Delete" }}
                    className={styles.actionIconButton}
                    onClick={() => {
                      setDeleteCoordinatorItem(item);
                      isDeleteCoordinator(true);
                      showReportDistributionModal();
                    }}
                  />
                )}
            </TooltipHost>
          </Stack>
        );
      },
    },
  ];
  const columnsRecipientsManagement: IColumn[] = [
    {
      key: "column1",
      name: "E-mail",
      fieldName: "email",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "columnName",
      name: "Name",
      fieldName: "name",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
      onRender: (item: any) => (
        <>
          {item.name}
          {item.lastName ? ` ${item.lastName}` : ""}
        </>
      ),
    },
    // {
    //   key: "columnName",
    //   name: "First name",
    //   fieldName: "name",
    //   minWidth: 100,
    //   maxWidth: 200,
    //   isRowHeader: true,
    //   data: "string",
    // },
    // {
    //   key: "columnLastname",
    //   name: "Last name",
    //   fieldName: "lastName",
    //   minWidth: 100,
    //   maxWidth: 200,
    //   isRowHeader: true,
    //   data: "string",
    // },
    {
      key: "columnCompany",
      name: "Company",
      fieldName: "companyName",
      minWidth: 80,
      maxWidth: 120,
      isRowHeader: true,
      data: "string",
    },
    {
      key: "column2",
      name: "autoSendTermsCondition",
      fieldName: "autoSendTermsCondition",
      minWidth: 25,
      maxWidth: 25,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="center" style={{ paddingTop: 3 }}>
            <TooltipHost
              content="Automatic distribution of terms acceptance invitation"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <Checkbox
                defaultChecked={item.autoSendTermsCondition}
                checked={item.autoSendTermsCondition}
                disabled={
                  project.status != "Draft" || item.termsConditionAccepted
                }
                styles={{ root: { marginLeft: -1 } }}
                onChange={(ev, checked) => {
                  onChangeCheckBox(item, "tac", ev, checked);
                }}
              />
            </TooltipHost>
          </Stack>
        );
      },
      onRenderHeader: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="center" style={{ paddingTop: 12 }}>
            <TooltipHost
              content="Automatic distribution of terms acceptance invitations (for all recipients)"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              <Checkbox
                indeterminate={indeterminateAutoTAC}
                checked={checkedTAC}
                onChange={(ev, checked) => {
                  if (checked) {
                    isCheckedTAC(true);
                    isSelectAllcheckBoxTAC(true);
                    showRecipientModal();
                  } else {
                    onChangeTAC(ev, checked);
                  }
                }}
                disabled={project.status != "Draft"}
              />
            </TooltipHost>
          </Stack>
        );
      },
    },
    {
      key: "column3",
      name: "Invitation to terms acceptance",
      fieldName: "sentTermsCondition",
      minWidth: 120,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="center">
            {/* {!item.sentTermsCondition && item.acceptanceDate == undefined && ( */}
            {item.sentTermsCondition && item.acceptanceDate == undefined && (
              <TooltipHost
                content="Invitation to terms acceptance sent"
                calloutProps={calloutProps}
                styles={hostStyles}
              >
                <IconButton
                  iconProps={completedIconGreen}
                  style={{ width: 24, height: 24 }}
                />
              </TooltipHost>
            )}
            {item.acceptanceDate == undefined && project.status == "Active" && (
              <>
                <TooltipHost
                  content={
                    item.sentTermsCondition && item.acceptanceDate == undefined
                      ? "Resend terms acceptance invitation"
                      : "Send terms acceptance invitation"
                  }
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton
                    iconProps={mailIcon}
                    title={
                      item.sentTermsCondition &&
                      item.acceptanceDate == undefined
                        ? "Resend terms acceptance invitation"
                        : "Send terms acceptance invitation"
                    }
                    className={styles.actionIconButton}
                    // onClick={() => onSendNotificationOrReport(item, false)}
                    onClick={() => {
                      isSentTac(true);
                      setRecipientItem(item);
                      showModalSendTacOrReport();
                    }}
                    disabled={project.status == "Archived"}
                  />
                </TooltipHost>
                <TooltipHost
                  content="Copy link to terms acceptance"
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton
                    iconProps={copyIcon}
                    title="Copy link to terms acceptance"
                    className={styles.actionIconButton}
                    onClick={() => onCopyNotificationOrReportLink(item, false)}
                    disabled={project.status == "Archived"}
                  />
                </TooltipHost>
              </>
            )}
          </Stack>
        );
      },
    },
    {
      key: "column4",
      name: "Acceptance tracking",
      fieldName: "acceptanceDate",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        if (item.acceptanceDate)
          return (
            <>
              {item.acceptanceDate != undefined && (
                <TooltipHost
                  content="Terms accepted"
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton iconProps={completedIconGreen} />
                  {_onFormatDate(item.acceptanceDate)}
                </TooltipHost>
              )}
            </>
          );
      },
    },
    // {
    //   key: "column5",
    //   name: "autoSendReport",
    //   fieldName: "autoSendReport",
    //   minWidth: 25,
    //   maxWidth: 25,
    //   isRowHeader: true,
    //   data: "string",
    //   isPadded: false,
    //   onRender: (item: any) => {
    //     return (
    //       <Stack horizontal horizontalAlign="center" style={{ paddingTop: 3 }}>
    //         <TooltipHost
    //           content="Automatic distribution of e-mail with link to download report(s)"
    //           calloutProps={calloutProps}
    //           styles={hostStyles}
    //         >
    //           <Checkbox
    //             defaultChecked={item.autoSendReport}
    //             checked={item.autoSendReport}
    //             onChange={(ev, checked) => {
    //               onChangeCheckBox(item, "report", ev, checked);
    //             }}
    //             disabled={
    //               item.acceptanceDate != undefined ||
    //               project.status == "Archived" ||
    //               project.documents == undefined ||
    //               project.documents == null ||
    //               project.documents.length == 0
    //             }
    //           ></Checkbox>
    //         </TooltipHost>
    //       </Stack>
    //     );
    //   },
    //   onRenderHeader: (item: any) => {
    //     return (
    //       <Stack horizontal horizontalAlign="center" style={{ paddingTop: 12 }}>
    //         <TooltipHost
    //           content="Automatic distribution of e-mail with link to download report(s) (for all recipients)"
    //           calloutProps={calloutProps}
    //           styles={hostStyles}
    //         >
    //           <Checkbox
    //             indeterminate={indeterminateAutoReport}
    //             checked={checkedReport}
    //             onChange={(ev, checked) => {
    //               if (checked) {
    //                 isCheckedReport(true);
    //                 isSelectAllcheckBoxReport(true);
    //                 showRecipientModal();
    //               } else {
    //                 onChangeReport(ev, checked);
    //               }
    //             }}
    //             disabled={
    //               disableAllCheckboxReport ||
    //               project.status == "Archived" ||
    //               project.documents == undefined ||
    //               project.documents == null ||
    //               project.documents.length == 0
    //             }
    //           />
    //         </TooltipHost>
    //       </Stack>
    //     );
    //   },
    // },
    // {
    //   key: "column6",
    //   name: "Distribution of download link",
    //   fieldName: "sendReport",
    //   minWidth: 120,
    //   maxWidth: 200,
    //   isRowHeader: true,
    //   data: "string",
    //   isPadded: false,
    //   onRender: (item: any) => {
    //     return (
    //       <Stack horizontal horizontalAlign="center">
    //         {item.acceptanceDate != undefined &&
    //           (project.documents != undefined || project.documents != null) &&
    //           project.status == "Active" && (
    //             <>
    //               <TooltipHost
    //                 content="(Re)send e-mail with link to download report(s)"
    //                 calloutProps={calloutProps}
    //                 styles={hostStyles}
    //               >
    //                 <IconButton
    //                   iconProps={mailIcon}
    //                   title="(Re)send e-mail with link to download report(s)"
    //                   className={styles.actionIconButton}
    //                   // onClick={() => onSendNotificationOrReport(item, true)}
    //                   onClick={() => {
    //                     isSentReport(true);
    //                     setRecipientItem(item);
    //                     showModalSendTacOrReport();
    //                   }}
    //                   disabled={
    //                     project.status == "Archived" ||
    //                     project.documents == undefined ||
    //                     project.documents == null ||
    //                     project.documents.length == 0
    //                   }
    //                 />
    //               </TooltipHost>
    //               <TooltipHost
    //                 content="Copy link to download report(s)"
    //                 calloutProps={calloutProps}
    //                 styles={hostStyles}
    //               >
    //                 <IconButton
    //                   iconProps={copyIcon}
    //                   className={styles.actionIconButton}
    //                   onClick={() => onCopyNotificationOrReportLink(item, true)}
    //                   disabled={
    //                     project.status == "Archived" ||
    //                     project.documents == undefined ||
    //                     project.documents == null ||
    //                     project.documents.length == 0
    //                   }
    //                 />
    //               </TooltipHost>
    //               {(item.sentReport ||
    //                 (item.acceptanceDate != undefined &&
    //                   item.autoSendReport)) && (
    //                 <TooltipHost
    //                   content="Report downloaded"
    //                   calloutProps={calloutProps}
    //                   styles={hostStyles}
    //                 >
    //                   <IconButton iconProps={completedIconGreen} />
    //                 </TooltipHost>
    //               )}
    //             </>
    //           )}
    //       </Stack>
    //     );
    //   },
    // },
    // {
    //   key: "column7",
    //   name: "Download date",
    //   fieldName: "",
    //   minWidth: 100,
    //   // maxWidth: 200,
    //   isRowHeader: true,
    //   data: "string",
    //   isPadded: false,
    //   isResizable: true,
    //   onRender: (item: any) => {
    //     return (
    //       item.documents != null &&
    //       item.documents.map((x: any) => {
    //         if (x.isDownloaded)
    //           return (
    //             <div key={x.id}>
    //               {x.fileName} {_onFormatDate(x.downloadDate)}
    //             </div>
    //           );
    //       })
    //     );
    //   },
    // },
    {
      key: "column8",
      name: "",
      fieldName: "name",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <Stack horizontal horizontalAlign="end">
            <TooltipHost
              content="Delete recipient"
              calloutProps={calloutProps}
              styles={hostStyles}
            >
              {project.status != "Archived" &&
                (project.owner?.includes(currentUser?.email) ||
                  project.contributor?.includes(currentUser?.email)) &&
                !(
                  item.termsConditionAccepted ||
                  item.sentTermsCondition ||
                  item.acceptanceDate
                ) && (
                  <IconButton
                    iconProps={{ iconName: "Delete" }}
                    className={styles.actionIconButton}
                    onClick={() => {
                      setDeleteRecipientItem(item);
                      isDeleteRecipient(true);
                      showRecipientModal();
                    }}
                  />
                )}
            </TooltipHost>
          </Stack>
        );
      },
    },
  ];
  const columnsRecipientsManagementModal: IColumn[] = [
    {
      key: "column1",
      name: "E-mail",
      isRowHeader: true,
      fieldName: "email",
      minWidth: 100,
      maxWidth: 150,
      className: columnStyle,
    },
  ];
  const columnsReportDistributionModal: IColumn[] = [
    {
      key: "column1",
      name: "E-mail",
      fieldName: "email",
      minWidth: 150,
      maxWidth: 200,
      isRowHeader: true,
      className: columnStyle,
    },
    {
      key: "column2",
      name: "First name",
      fieldName: "name",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      className: columnStyle,
    },
    {
      key: "column3",
      name: "Last name",
      fieldName: "surname",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      className: columnStyle,
    },
    {
      key: "column4",
      name: "Company",
      fieldName: "companyName",
      minWidth: 100,
      maxWidth: 150,
      isRowHeader: true,
      className: columnStyle,
    },
  ];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const columnsReportDocument: IColumn[] = [
    {
      key: "column1",
      name: "Name",
      fieldName: "fileName",
      minWidth: 300,
      maxWidth: 400,
    },
    {
      key: "column2",
      name: "Upload date",
      fieldName: "uploadDate",
      minWidth: 200,
      maxWidth: 200,
      isRowHeader: true,
      isPadded: false,
      onRender: (item: any) => {
        return _onFormatDate(item.uploadDate);
      },
    },
    {
      key: "column3",
      name: "Upload by",
      fieldName: "uploadedBy",
      minWidth: 100,
      maxWidth: 200,
      isRowHeader: true,
      isPadded: false,
    },

    {
      key: "column4",
      name: "",
      fieldName: "",
      minWidth: 100,
      maxWidth: 100,
      isRowHeader: true,
      data: "string",
      isPadded: false,
      onRender: (item: any) => {
        return (
          <>
            <Stack horizontal horizontalAlign="end">
              {project.owner?.includes(currentUser?.email) &&
                project.status != "Archived" &&
                item.isDisabled && (
                  <TooltipHost
                    content="Enable report document"
                    calloutProps={calloutProps}
                    styles={hostStyles}
                  >
                    <IconButton
                      iconProps={{ iconName: "View" }}
                      className={styles.actionIconButton}
                      onClick={() => {
                        onDisableDocument(
                          item.fileName,
                          project.projectId,
                          false,
                        );
                      }}
                    />
                  </TooltipHost>
                )}
              {project.owner?.includes(currentUser?.email) &&
                project.status == "Active" &&
                item.isDisabled != true && (
                  <TooltipHost
                    content="Disable document"
                    calloutProps={calloutProps}
                    styles={hostStyles}
                  >
                    <IconButton
                      iconProps={{ iconName: "Hide3Icon" }}
                      className={styles.actionIconButton}
                      onClick={() => {
                        onDisableDocument(
                          item.fileName,
                          project.projectId,
                          true,
                        );
                      }}
                    />
                  </TooltipHost>
                )}
              {project.owner?.includes(currentUser?.email) &&
                project.status != "Archived" &&
                project.status == "Draft" && (
                  <TooltipHost
                    content="Delete document"
                    calloutProps={calloutProps}
                    styles={hostStyles}
                  >
                    <IconButton
                      iconProps={{ iconName: "Delete" }}
                      className={styles.actionIconButton}
                      onClick={() => {
                        onDeleteProjectDocument(item as IReportDocument);
                      }}
                    />
                  </TooltipHost>
                )}
              {project.status != "Archived" && (
                <TooltipHost
                  content="Download document"
                  calloutProps={calloutProps}
                  styles={hostStyles}
                >
                  <IconButton
                    iconProps={{ iconName: "DownloadDocument" }}
                    className={styles.actionIconButton}
                    onClick={() => {
                      if (item.fileLink)
                        onDownloadDocument(item.fileLink, item.fileName);
                    }}
                    disabled={item.isDisabled}
                  />
                </TooltipHost>
              )}
            </Stack>
          </>
        );
      },
    },
  ];
  const dropdownStyles: Partial<IDropdownStyles> = {
    root: { paddingRight: 50, paddingBottom: 10 },
    dropdown: { width: 300 },
  };

  const textfieldStyles: Partial<ITextFieldStyles> = {
    root: {
      width: 350,
      paddingRight: 50,
      paddingBottom: 10,
    },
  };
  const getLabelStyles = (): ILabelStyles => {
    return {
      root: {
        color: "rgb(161, 159, 157)",
      },
    };
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const textfieldmodalStyles: Partial<ITextFieldStyles> = {
    root: {
      width: 350,
      paddingRight: 50,
      paddingBottom: 10,
    },
    fieldGroup: {
      borderBottom: "1px solid rgb(96, 94, 92)",
    },
    field: {
      fontWeight: "bold",
    },
    subComponentStyles: {
      label: getLabelStyles,
    },
  };

  const projectListIcon: IIconProps = {
    iconName: "DoubleChevronLeftIcon",
    styles: {
      root: [
        {
          selectors: {
            ">span": {
              verticalAlign: "top",
            },
          },
        },
      ],
    },
  };
  const completedIconGreen: IIconProps = {
    iconName: "CompletedIcon",
    styles: {
      root: [
        {
          fontSize: 20,
          height: 24,
          width: 24,
          color: "green",
          selectors: {
            ">span": {
              verticalAlign: "top",
            },
          },
        },
      ],
    },
  };
  const mailIcon: IIconProps = {
    iconName: "MailIcon",
    styles: {
      root: [
        {
          fontSize: 20,
          height: 20,
          width: 20,
        },
      ],
    },
  };
  const copyIcon: IIconProps = {
    iconName: "CopyIcon",
    styles: {
      root: [
        {
          fontSize: 20,
          height: 20,
          width: 20,
        },
      ],
    },
  };
  const addRecipient = () => {
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    if (!emailRegex.test(recipientEmail)) {
      setErrorMessageEmail("E-mail not valid");
    } else {
      setErrorMessageEmail("");
      let recipientCheckOnModal = recipientManagementModal.filter((u: any) => {
        return u.email == recipientEmail;
      });
      let recipientCheckOnList = itemsRecipientsManagement.filter((u: any) => {
        return u.email == recipientEmail;
      });
      if (recipientCheckOnModal.length > 0) {
        setErrorMessageEmail("E-mail address already added");
        return;
      }
      if (recipientCheckOnList.length > 0) {
        if (recipientCheckOnList[0].isDeleted) {
          let rec = recipientCheckOnList[0];
          rec.isDeleted = false;
          rec.deletedTime = undefined;
          rec.documents = [];
          setRecipientManagementModal([...recipientManagementModal, rec]);
          setRecipientEmail("");
        } else {
          setErrorMessageEmail("E-mail address already exists in the list");
        }

        return;
      }

      setRecipientManagementModal([
        ...recipientManagementModal,
        {
          recipientId: crypto.randomUUID(),
          email: recipientEmail,
          autoSendReport: false,
          sentReport: false,

          autoSendTermsCondition: checkedTAC && project.status == "Draft",
          sentTermsCondition: false,
          termsConditionAccepted: false,
          isDeleted: false,
          documents: project.documents,
        },
      ]);
      setRecipientEmail("");
      setNumberSelectedRecipients(numberSelectedRecipients + 1);
    }
  };
  const addCoordinator = () => {
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
    if (!emailRegex.test(coordinatorEmail)) {
      setErrorMessageCoordinatorEmail("E-mail not valid");
    } else {
      setErrorMessageCoordinatorEmail("");
      let recipientCheckOnModal = reportDistributionModal.filter((u: any) => {
        return u.email == coordinatorEmail;
      });
      let recipientCheckOnList = itemsReportDistribution.filter((u: any) => {
        return u.email == coordinatorEmail;
      });
      if (recipientCheckOnModal.length > 0) {
        setErrorMessageCoordinatorEmail("E-mail address already added");
        return;
      }
      if (recipientCheckOnList.length > 0) {
        setErrorMessageCoordinatorEmail(
          "E-mail address already exists in the list",
        );
        return;
      }

      setReportDistributionModal([
        ...reportDistributionModal,
        {
          id: crypto.randomUUID(),
          email: coordinatorEmail,
          companyName: coordinatorCompanyName,
          name: coordinatorName,
          surname: coordinatorSurname,
        },
      ]);
      setCoordinatorEmail("");
      setCoordinatorName("");
      setCoordinatorCompanyName("");
      setCoordinatorSurname("");
    }
  };

  const onDeleteRecipient = (item: any) => {
    if (project.status == "Draft") {
      let result = project.recipients.filter(function (obj: any) {
        return obj.email != item.email;
      });
      setItemsRecipientsManagement(result);
      let obj = project as IProject;
      obj.recipients = result;
      service.Update(obj).then((data: any) => {
        if (data?.error) {
          setMessageRecipient(`Error: ${data?.error}`);
          setMessageBarTypeRecipient(MessageBarType.error);
        } else {
          setMessageRecipient(`Recipient deleted successfully`);
          setMessageBarTypeRecipient(MessageBarType.success);
        }
        resetModalRecipient();
        setTimeout(resetMessageRecipient, 10000);
      });
    } else {
      if (project.status == "Active") {
        service
          .DeleteRecipient(project.projectId, item.recipientId)
          .then((data: any) => {
            if (data?.error) {
              setMessageRecipient(`Error: ${data?.error}`);
              setMessageBarTypeRecipient(MessageBarType.error);
            } else {
              setMessageRecipient(`Recipient deleted successfully`);
              setMessageBarTypeRecipient(MessageBarType.success);
              getProject();
            }
            resetModalRecipient();
            setTimeout(resetMessageRecipient, 10000);
          });
      }
    }
  };

  const onDeleteCoordinator = (item: any) => {
    if (
      project.coordinators?.length === 1 &&
      project.coordinators[0].id === item.id
    ) {
      setMessageReportDistribution(
        `Error: At least one coordiantor is required`,
      );
      setMessageBarTypeReportDistribution(MessageBarType.error);
      resetModalReportDistribution();
      setTimeout(resetMessageReportDistribution, 10000);
      return;
    }

    if (project.status == "Draft") {
      let result = project.coordinators?.filter(function (obj: any) {
        return obj.email != item.email;
      });
      setItemsReportDistribution(result);
      let obj = project as IProject;
      obj.coordinators = result;
      service.Update(obj).then((data: any) => {
        if (data?.error) {
          setMessageReportDistribution(`Error: ${data?.error}`);
          setMessageBarTypeReportDistribution(MessageBarType.error);
        } else {
          setMessageReportDistribution(
            `Report distribution coordinator deleted successfully`,
          );
          setMessageBarTypeReportDistribution(MessageBarType.success);
        }
        resetModalReportDistribution();
        setTimeout(resetMessageReportDistribution, 10000);
      });
    } else {
      if (project.status == "Active") {
        service
          .DeleteCoordinator(project.projectId, item.id)
          .then((data: any) => {
            if (data?.error) {
              setMessageReportDistribution(`Error: ${data?.error}`);
              setMessageBarTypeReportDistribution(MessageBarType.error);
            } else {
              setMessageReportDistribution(
                `Report distribution coordinator deleted successfully`,
              );
              setMessageBarTypeReportDistribution(MessageBarType.success);
              getProject();
            }
            resetModalReportDistribution();
            setTimeout(resetMessageReportDistribution, 10000);
          });
      }
    }
  };

  const resetModal = () => {
    hideModal();
    isEditPermission(false);
    isDeletePermission(false);
    setDeletePermissionItem(null);

    setItemsAccessManagementModal([]);
  };
  const resetModalRecipient = () => {
    hideRecipientModal();
    setRecipientManagementModal([]);
    isSelectAllcheckBoxReport(false);
    isSelectAllcheckBoxTAC(false);

    // setDeleteRecipientItem(null);
    isDeleteRecipient(false);
  };
  const resetModalReportDistribution = () => {
    hideReportDistributionModal();
    setReportDistributionModal([]);
    isDeleteRecipient(false);
    isDeleteCoordinator(false);
    setDeleteCoordinatorItem(null);
  };
  const merge = (a: any, b: any[], predicate = (a: any, b: any) => a === b) => {
    const c = [...a]; // copy to avoid side effects
    // add all items from B to copy C if they're not already present
    b.forEach((bItem) =>
      c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem),
    );
    return c;
  };
  const onAddRecipientToManagement = () => {
    let res: IRecipientsManagement[] = [];
    res = merge(
      recipientManagementModal,
      itemsRecipientsManagement,
      (a, b) => a.recipientId === b.recipientId,
    );

    setItemsRecipientsManagement(res);
    let obj = project as IProject;
    obj.recipients = res;
    setProject(obj);
    service.Update(obj).then((data: any) => {
      if (data?.error) {
        setMessageRecipient(`Error: ${data?.error}`);
        setMessageBarTypeRecipient(MessageBarType.error);
      } else {
        setMessageRecipient(`Recipient(s) added successfully`);
        setMessageBarTypeRecipient(MessageBarType.success);
      }
      setTimeout(resetMessageRecipient, 10000);
    });
    resetModalRecipient();
  };

  const onAddCoordinatorsToManagement = () => {
    let res: ICoordinator[] = [];
    res = merge(
      reportDistributionModal,
      itemsReportDistribution,
      (a, b) => a.id === b.id,
    );

    setItemsReportDistribution(res);
    let obj = project as IProject;
    obj.coordinators = res;
    setProject(obj);
    service.Update(obj).then((data: any) => {
      if (data?.error) {
        setMessageReportDistribution(`Error: ${data?.error}`);
        setMessageBarTypeReportDistribution(MessageBarType.error);
      } else {
        setMessageReportDistribution(`Coordinator(s) added successfully`);
        setMessageBarTypeReportDistribution(MessageBarType.success);
      }
      setTimeout(resetMessageReportDistribution, 10000);
    });
    resetModalReportDistribution();
  };

  const onCopyNotificationOrReportLink = (item: any, report: boolean) => {
    const appSettings = localStorage.getItem("appSettings") as any;
    if (appSettings) {
      const url = report
        ? JSON.parse(appSettings).customerAppUrl +
          "docgen/" +
          project.projectId +
          "/" +
          item.recipientId +
          "/"
        : JSON.parse(appSettings).customerAppUrl +
          "tac/" +
          project.projectId +
          "/" +
          item.recipientId +
          "/";

      navigator.clipboard.writeText(url);
      // Copying the link must NOT mark the invitation as sent. The "Invitation to
      // terms acceptance sent" tick should only appear when the link is actually
      // sent (onSendNotificationOrReport). So we only copy to clipboard here,
      // without mutating sentTermsCondition/sentReport or persisting the project.
      setMessageRecipient(`Invitation link copied to clipboard`);
      setMessageBarTypeRecipient(MessageBarType.success);
      setTimeout(resetMessageRecipient, 10000);
    }
  };
  const onSendNotificationOrReport = (item: any, report: boolean) => {
    hideModalSendTacOrReport();
    let obj = project;
    obj.recipients = [{ ...item }];
    if (report) {
      service.SendReportEmailToRecipient(obj as IProject).then((data: any) => {
        if (data?.error) {
          setMessageRecipient(`Error: ${data?.error}`);
          setMessageBarTypeRecipient(MessageBarType.error);
        } else {
          setMessageRecipient(`Report sent successfully`);
          setMessageBarTypeRecipient(MessageBarType.success);
          getProject();
        }
      });
    } else {
      service
        .SendNotificationEmailToRecipient(obj as IProject)
        .then((data: any) => {
          if (data?.error) {
            setMessageRecipient(`Error: ${data?.error}`);
            setMessageBarTypeRecipient(MessageBarType.error);
          } else {
            setMessageRecipient(`E-mail sent successfully`);
            setMessageBarTypeRecipient(MessageBarType.success);
            getProject();
          }
        });
    }
    setTimeout(resetMessageRecipient, 10000);
  };
  const onChangeTAC = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean,
  ) => {
    let result = project.recipients;
    result = result.map((e: any) => {
      e.autoSendTermsCondition = checked ? true : false;
      return e;
    });
    let obj = { ...project, recipients: result };
    if (result) {
      setItemsRecipientsManagement(result);
    }
    isCheckedTAC(checked ? true : false);
    isIndeterminateAutoTAC(false);
    service.Update(obj).then((data: any) => {
      if (data?.error) {
        setMessageRecipient(`Error: ${data?.error}`);
        setMessageBarTypeRecipient(MessageBarType.error);
      } else {
        // setMessageRecipient(`Recipients updated successfully`);
        // setMessageBarTypeRecipient(MessageBarType.success);
        setProject(obj);
        checkAllTac(obj);
      }
      resetModalRecipient();
      setTimeout(resetMessageRecipient, 10000);
    });
  };
  const onChangeReport = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean,
  ) => {
    let result = project.recipients;
    result = result.map((e: any) => {
      e.autoSendReport = checked ? true : false;
      return e;
    });
    let obj = { ...project, recipients: result };
    if (result) {
      setItemsRecipientsManagement(result);
    }
    isCheckedReport(checked ? true : false);
    isIndeterminateAutoReport(false);
    service.Update(obj).then((data: any) => {
      if (data?.error) {
        setMessageRecipient(`Error: ${data?.error}`);
        setMessageBarTypeRecipient(MessageBarType.error);
      } else {
        // setMessageRecipient(`Recipients updated successfully`);
        // setMessageBarTypeRecipient(MessageBarType.success);
        setProject(obj);
        checkAllReport(obj);
      }
      resetModalRecipient();
      setTimeout(resetMessageRecipient, 10000);
    });
  };
  const onChangeCheckBox = (
    item: any,
    field: string,
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    checked?: boolean,
  ) => {
    let result = project.recipients;
    if (field == "tac") {
      result = result.map((p: any) =>
        p.email === item.email ? { ...p, autoSendTermsCondition: checked } : p,
      );
    }
    if (field == "report") {
      result = result.map((p: any) =>
        p.email === item.email ? { ...p, autoSendReport: checked } : p,
      );
    }
    let obj = { ...project, recipients: result };
    if (result) {
      setItemsRecipientsManagement(result);
    }
    checkAllTac(obj);
    checkAllReport(obj);
    setProject(obj);
    service.Update(obj).then((data: any) => {
      if (data?.error) {
        setMessageRecipient(`Error: ${data?.error}`);
        setMessageBarTypeRecipient(MessageBarType.error);
      } else {
        // setMessageRecipient(`Recipients updated successfully`);
        // setMessageBarTypeRecipient(MessageBarType.success);
      }
      setTimeout(resetMessageRecipient, 10000);
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    var file = e.target.files![0];
    if (file) {
      const exist = reportDocumentManagement.some(
        (x) => x.fileName === file.name,
      );
      if (exist) {
        setMessageBarTypeReport(MessageBarType.warning);
        setMessageReport(
          `Report document with the same file name exists already.`,
        );
        setTimeout(resetMessageReport, 20000);
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          var arrayBuffer = reader.result as ArrayBuffer;
          var base64String = btoa(
            new Uint8Array(arrayBuffer).reduce(function (data, byte) {
              return data + String.fromCharCode(byte);
            }, ""),
          );
          let doc: IReportDocument = {
            fileName: file.name.trim(),
            fileData: base64String,
            uploadDate: new Date(),
            uploadedBy: currentUser?.displayName,
          };
          const exist = reportDocumentManagement.some(
            (x) => x.fileName === file.name.trim(),
          );
          if (exist) {
          } else {
          }

          service.UploadDocument(doc, project.projectId).then((result: any) => {
            if (result?.error) {
              setMessageReport(`Error: ${result?.error}`);
              setMessageBarTypeReport(MessageBarType.error);
              e.target.files = null;
            } else {
              setMessageReport(`Report uploaded successfully`);
              setMessageBarTypeReport(MessageBarType.success);
              setProject(result);
              setReportDocumentManagement(project.documents);
            }

            setTimeout(resetMessageReport, 20000);
          });
        };
        reader.readAsArrayBuffer(file);
      }
    }
  };
  const b64toBlob = (b64Data: string, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const onDownloadDocument = (fileLink: string, fileName: string) => {
    service.DownloadDocument(fileLink).then((data: string) => {
      var blob = b64toBlob(data as string);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
    });
  };
  const onDisableDocument = (
    fileName: string,
    projectId: string,
    disable: boolean,
  ) => {
    service
      .DisableDocument(fileName, projectId, disable)
      .then((result: any) => {
        if (result?.error) {
          setMessageReport(`Error: ${result?.error}`);
          setMessageBarTypeReport(MessageBarType.error);
        } else {
          if (disable) {
            setMessageReport(`Report document disabled successfully`);
          } else {
            setMessageReport(`Report document enabled successfully`);
          }

          setMessageBarTypeReport(MessageBarType.success);
          setProject(result);
          setReportDocumentManagement(result.documents);
          setItemsRecipientsManagement(result.recipients);
        }
      });
  };

  const onDeleteProjectDocument = (item: IReportDocument) => {
    service.DeleteDocument(item, project.projectId).then((data: any) => {
      if (data?.error) {
        setMessageReport(`Error: ${data?.error}`);
        setMessageBarTypeReport(MessageBarType.error);
      } else {
        setMessageReport(`Document deleted successfully`);
        setMessageBarTypeReport(MessageBarType.success);
        setProject(data);
      }
      setTimeout(resetMessageReport, 10000);
    });
  };
  const resetMessageRecipient = () => {
    setMessageRecipient("");
    setMessageBarTypeRecipient(undefined);
  };
  const resetMessageReportDistribution = () => {
    setMessageReportDistribution("");
    setMessageBarTypeReportDistribution(undefined);
  };
  const resetMessageReport = () => {
    setMessageReport("");
    setMessageBarTypeReport(undefined);
  };
  const resetMessage = () => {
    setMessage("");
    setMessageBarType(undefined);
  };
  const resetMessagePermission = () => {
    setMessagePermission("");
    setMessageBarTypePermission(undefined);
  };
  const getProject = () => {
    if (projectId) {
      startLoadingProject();
      service
        .GetById(projectId)
        .then((data: IProject) => {
          setProject(data);
          if (data.recipients) {
            setItemsRecipientsManagement(data.recipients);
          }
          if (data.coordinators) {
            setItemsReportDistribution(data.coordinators);
          }
        })
        .finally(() => {
          stopLoadingProject();
        });
    }
  };
  const onArchiveProject = () => {
    if (project?.status != "Archived") {
      let obj = project;
      obj.status = "Archived";
      service.Update(obj as IProject).then((result: any) => {
        if (result?.error) {
          setMessage(`Error: ${result?.error}`);
          setMessageBarType(MessageBarType.error);
        } else {
          setMessage(`Project archived successfully`);
          setMessageBarType(MessageBarType.success);
        }
        setTimeout(resetMessage, 10000);
        hideArchiveModal();
      });
    }
  };
  const onReactivateProject = () => {
    if (project?.status == "Archived") {
      let obj = project;
      obj.status = "Active";
      service.Update(obj as IProject).then((result: any) => {
        if (result?.error) {
          setMessage(`Error: ${result?.error}`);
          setMessageBarType(MessageBarType.error);
        } else {
          setMessage(`Project reactivated successfully`);
          setMessageBarType(MessageBarType.success);
        }
        setTimeout(resetMessage, 10000);
        hideReactivateModal();
      });
    }
  };
  const getItemAccessManagement = async () => {
    let contributors =
      project.contributor?.split(";") != undefined
        ? project.contributor?.split(";").filter(Boolean)
        : [];
    let owners =
      project.owner?.split(";") != undefined
        ? project.owner?.split(";").filter(Boolean)
        : [];
    let contributorsResult: any[] = [];
    let ownersResult: any[] = [];

    let allUsers = await graphService.getUserBatch(contributors.concat(owners));

    contributors?.forEach((item: any) => {
      let user = allUsers.filter((u: any) => {
        return u.mail == item;
      });
      if (user.length > 0)
        contributorsResult.push({ ...user[0], projectRole: "Member" });
    });
    owners?.forEach((item: any) => {
      let user = allUsers.filter((u: any) => {
        return u.mail == item;
      });
      if (user.length > 0)
        ownersResult.push({ ...user[0], projectRole: "Owner" });
    });
    setOwnersCount(owners.length);
    let resultSorted = ownersResult.concat(contributorsResult);
    setItemsAccessManagement(resultSorted);
    let currentSelectedUsers: IPersonaProps[] = [];
    resultSorted.forEach((element: { [x: string]: any }) => {
      let option = {
        key: element["mail"] || 0,
        text: element["displayName"] || "",
      };
      currentSelectedUsers.push(option);
    });
    setCurrentSelectedMembers(currentSelectedUsers);
  };

  const checkAllTac = (obj: any) => {
    if (obj?.recipients) {
      if (obj.recipients.length == 0) {
        isCheckedTAC(true);
        isIndeterminateAutoTAC(false);
      } else {
        let result = obj.recipients.filter((e: any) => {
          return e.autoSendTermsCondition == true;
        });
        if (result.length == 0) {
          isCheckedTAC(false);
          isIndeterminateAutoTAC(false);
        } else {
          if (result.length == obj.recipients.length) {
            isCheckedTAC(true);
            isIndeterminateAutoTAC(false);
          } else {
            isCheckedTAC(false);
            isIndeterminateAutoTAC(true);
          }
        }
      }
    }
  };
  const checkAllReport = (obj: any) => {
    if (obj?.recipients) {
      let result = obj.recipients.filter((e: any) => {
        return e.autoSendReport == true;
      });
      if (result.length == 0) {
        isCheckedReport(false);
        isIndeterminateAutoReport(false);
      } else {
        if (result.length == obj.recipients.length) {
          isCheckedReport(true);
          isIndeterminateAutoReport(false);
        } else {
          isCheckedReport(false);
          isIndeterminateAutoReport(true);
        }
      }
    }
  };
  const selectAllCheckBoxes = () => {
    if (selectAllcheckBoxReport) onChangeReport(undefined, checkedReport);
    if (selectAllcheckBoxTAC) onChangeTAC(undefined, checkedTAC);
  };
  const getCompanies = () => {
    serviceCommon.GetAllCompanies().then((result: any) => {
      if (result.error) {
        setMessage(`Error: ${result?.error}`);
        setMessageBarType(MessageBarType.error);
      } else {
        let ddpOptions: IDropdownOption[] = [];
        let res = result as ICommon[];
        if (res.length > 0) {
          res.forEach((element) => {
            if (!element.company?.companyCode) return;

            ddpOptions.push({
              key: element.company?.companyCode,
              text: `${element.company?.country} / ${element.company?.companyName}`,
              title: element.company?.companyName,
              disabled: !element.company?.active || element.company?.isDeleted,
              hidden: element.company?.isDeleted,
            });
          });
          setCompanies(ddpOptions);
        } else {
          setMessage("No company is found.");
          setMessageBarType(MessageBarType.warning);
        }
      }
      setTimeout(resetMessage, 10000);
    });
  };
  useEffect(() => {
    const localCurrentUser = localStorage.getItem("currentUser");
    if (typeof localCurrentUser === "string") {
      const user = JSON.parse(localCurrentUser);
      setCurrentUser(user);
    }
    getProject();
    getCompanies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      currentUser != undefined &&
      project.projectId != undefined &&
      currentUser.isLegal == false
    ) {
      if (
        !(
          project.owner?.includes(currentUser?.email) ||
          project.contributor?.includes(currentUser?.email)
        )
      ) {
        navigate("/notfound");
      }
    }
    isShowPanel(
      projectId == "" ||
        (projectId != "" &&
          (project.owner?.includes(currentUser?.email) ||
            project.contributor?.includes(currentUser?.email) ||
            currentUser?.isLegal)),
    );
    isShowSaveBtn(
      projectId == "" ||
        (projectId != "" &&
          (project.owner?.includes(currentUser?.email) ||
            project.contributor?.includes(currentUser?.email)) &&
          project.status == "Draft"),
    );
    if (project.recipients != undefined && project.recipients.length > 0) {
      let selectedRecipients = project.recipients.filter(
        (e: IRecipientsManagement) => {
          return e.autoSendTermsCondition == true;
        },
      );
      setNumberSelectedRecipients(selectedRecipients.length);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project, currentUser]);
  useEffect(() => {
    if (project.owner || project.contributor) {
      getItemAccessManagement();
    }
    if (project.recipients) {
      setItemsRecipientsManagement(project.recipients);
      checkAllTac(project);
      checkAllReport(project);
    }
    if (project.documents != undefined) {
      setReportDocumentManagement(project.documents);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);
  useEffect(() => {
    if (project.company != null && companies.length > 0) {
      const company: any = companies.find((e) => {
        return e.key == project?.company;
      });
      if (company != null) setSelectedCompany(company.key);
    }
  }, [project, companies]);

  useEffect(() => {
    if (itemsRecipientsManagement)
      isDisableAllCheckboxReport(
        itemsRecipientsManagement.some((x) => x.acceptanceDate != undefined),
      );
  }, [itemsRecipientsManagement]);

  // const onBccDistributionManagementChanged = (checked: boolean | undefined) => {
  //   let obj = project as IProject;
  //   obj.bccDistributionManagement = checked;
  //   setProject({ ...obj });
  //   service.Update(obj).then((data: any) => {
  //     if (data?.error) {
  //       setMessageReportDistribution(`Error: ${data?.error}`);
  //       setMessageBarTypeReportDistribution(MessageBarType.error);
  //       obj.bccDistributionManagement = !checked;
  //       setProject({ ...obj });
  //       setTimeout(resetMessageReportDistribution, 10000);
  //     }
  //   });
  // };
  // const onBccRecipientManagementChanged = (checked: boolean | undefined) => {
  //   let obj = project as IProject;
  //   obj.bccRecipientManagement = checked;
  //   setProject({ ...obj });
  //   service.Update(obj).then((data: any) => {
  //     if (data?.error) {
  //       setMessageRecipient(`Error: ${data?.error}`);
  //       setMessageBarTypeRecipient(MessageBarType.error);
  //       obj.bccRecipientManagement = !checked;
  //       setProject({ ...obj });
  //       setTimeout(resetMessageRecipient, 10000);
  //     }
  //   });
  // };

  const onChangeBcc = (
    mail: string | undefined,
    checked: boolean | undefined,
  ) => {
    let obj = project as IProject;
    let initialBcc = obj.bcc ? [...obj.bcc] : [];
    let newBcc = obj.bcc ? [...obj.bcc] : [];
    if (checked) {
      if (mail && !newBcc.includes(mail)) {
        newBcc.push(mail);
      }
    } else {
      newBcc = newBcc.filter((item) => item !== mail);
    }
    obj.bcc = newBcc;
    setProject({ ...obj });
    service.Update(obj).then((data: any) => {
      if (data?.error) {
        obj.bcc = initialBcc;
        setProject({ ...obj });
      }
    });
  };

  return (
    <>
      {showPanel && (
        <Stack>
          <Stack horizontal horizontalAlign="space-between">
            <Stack horizontal horizontalAlign="start">
              <Label className={styles.PageHeader}>
                {projectId == "" ? "New project" : "Project details"}
              </Label>
            </Stack>
            <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: 8 }}>
              {currentUser?.isLegal && projectId !== "" && (
                <PrimaryButton
                  text="Terms Logs"
                  className={styles.buttonNewProject}
                  onClick={() => navigate(`/termslogs/${projectId}`)}
                />
              )}
              <PrimaryButton
                text="Project list"
                className={styles.buttonNewProject}
                iconProps={projectListIcon}
                onClick={routeChange}
              />
            </Stack>
          </Stack>
          <Stack>
            <hr className={styles.horizontalLine}></hr>
          </Stack>
          {message != "" && (
            <Stack>
              <MessageBar
                messageBarType={messageBarType}
                isMultiline={false}
                dismissButtonAriaLabel="Close"
                onDismiss={resetMessage}
              >
                {message}
              </MessageBar>
            </Stack>
          )}

          <Stack horizontal verticalAlign="center">
            <Label className={styles.contentHeader}>General information</Label>
          </Stack>
          <Stack horizontal horizontalAlign="start">
            <TextField
              label="Project name"
              value={project?.name}
              required
              styles={textfieldStyles}
              onChange={(ev, val) => {
                if (project?.status == "Draft")
                  onChangeTxtField(ev, "name", val);
              }}
              disabled={projectId != "" && project.status != "Draft"}
              errorMessage={
                project?.name == "" || project.name == undefined
                  ? errorMessageFieldRequired
                  : undefined
              }
            />
            <Dropdown
              placeholder="Please select"
              label="Category"
              options={categories}
              styles={dropdownStyles}
              defaultSelectedKey={project?.category}
              selectedKey={project?.category}
              required
              onChange={(ev, option) => {
                if (project?.status == "Draft")
                  onDropDownChange(ev, "category", option);
              }}
              disabled={projectId != "" && project.status != "Draft"}
              errorMessage={project?.category ? "" : errorMessageFieldRequired}
            />
            <Dropdown
              placeholder="Please select"
              label="Roland Berger entity"
              options={companies.sort(function (a, b) {
                return a.text.localeCompare(b.text);
              })}
              styles={dropdownStyles}
              defaultSelectedKey={selectedCompany}
              selectedKey={selectedCompany}
              required
              id="Company"
              onChange={(ev, option) => {
                if (project?.status == "Draft")
                  onDropDownChange(ev, "company", option);
              }}
              disabled={projectId != "" && project?.status != "Draft"}
              errorMessage={project?.company ? "" : errorMessageFieldRequired}
            />
          </Stack>
          <Stack horizontal horizontalAlign="start">
            <TextField
              label="Client name"
              id="Client"
              value={project?.client}
              required
              styles={textfieldStyles}
              onChange={(ev, val) => {
                if (project?.status == "Draft")
                  onChangeTxtField(ev, "client", val);
              }}
              disabled={projectId != "" && project?.status != "Draft"}
              errorMessage={project?.client ? "" : errorMessageFieldRequired}
            />
            <TextField
              label="Target name"
              id="Target"
              value={project?.target}
              required
              styles={textfieldStyles}
              onChange={(ev, val) => {
                if (project?.status == "Draft")
                  onChangeTxtField(ev, "target", val);
              }}
              disabled={projectId != "" && project?.status != "Draft"}
              errorMessage={project?.target ? "" : errorMessageFieldRequired}
            />
          </Stack>
          {projectId != "" && (
            <Stack>
              <Stack horizontal horizontalAlign="start">
                <Label>Status</Label>
              </Stack>
              <Stack
                horizontal
                horizontalAlign="start"
                style={{ minWidth: 100 }}
              >
                {project?.status == "Archived" && (
                  <>
                    <Label
                      disabled
                      className={styles.Archived}
                      style={{ marginRight: 10 }}
                    >
                      {project?.status}
                    </Label>
                    {(project.owner?.includes(currentUser?.email) ||
                      project.contributor?.includes(currentUser?.email)) && (
                      <TooltipHost
                        content="Reactivate project"
                        calloutProps={calloutProps}
                        styles={hostStyles}
                      >
                        <IconButton
                          iconProps={{
                            iconName: "PlaybackRate1xIcon",
                            styles: {
                              root: [
                                {
                                  selectors: {
                                    ">span": {
                                      verticalAlign: "top",
                                    },
                                  },
                                },
                              ],
                            },
                          }}
                          onClick={() => {
                            showReactivateModal();
                          }}
                          className={styles.actionIconButton}
                        />
                      </TooltipHost>
                    )}
                  </>
                )}
                {project?.status == "Active" && (
                  <>
                    <Label
                      disabled
                      className={styles.Active}
                      style={{ marginRight: 10 }}
                    >
                      {project?.status}
                    </Label>
                    {(project.owner?.includes(currentUser?.email) ||
                      project.contributor?.includes(currentUser?.email)) && (
                      <TooltipHost
                        content="Archive project"
                        calloutProps={calloutProps}
                        styles={hostStyles}
                      >
                        <IconButton
                          iconProps={{
                            iconName: "ArchiveIcon",
                            styles: {
                              root: [
                                {
                                  selectors: {
                                    ">span": {
                                      verticalAlign: "top",
                                    },
                                  },
                                },
                              ],
                            },
                          }}
                          onClick={() => {
                            showArchiveModal();
                          }}
                          className={styles.actionIconButton}
                        />
                      </TooltipHost>
                    )}
                  </>
                )}
                {project?.status == "Draft" && (
                  <Label disabled className={styles.Draft}>
                    {project?.status}
                  </Label>
                )}
                {!!project?.name && project?.status == "Draft" ? (
                  <div>
                    | Project will be displayed as{" "}
                    <strong>
                      {" "}
                      {project?.name} -{" "}
                      {categories.find((c) => c.key === project?.category)
                        ?.text || project?.category}{" "}
                      on {project?.target}
                    </strong>{" "}
                    in recipient communication - Please review
                  </div>
                ) : (
                  !!project?.name && (
                    <div>
                      |
                      <strong>
                        {" "}
                        {project?.name} -{" "}
                        {categories.find((c) => c.key === project?.category)
                          ?.text || project?.category}{" "}
                        on {project?.target}
                      </strong>
                    </div>
                  )
                )}
              </Stack>
            </Stack>
          )}
          {showSaveBtn && (
            <Stack horizontal horizontalAlign="end">
              <PrimaryButton
                text="Save"
                className={styles.buttonSave}
                onClick={onSubmitProject}
              />
            </Stack>
          )}
          {projectId != "" && (
            <>
              <Modal
                isOpen={isModalArchiveOpen}
                onDismiss={hideArchiveModal}
                isBlocking={false}
                containerClassName={contentStyles.archiveContainer}
              >
                <Stack style={{ padding: 20 }}>
                  <Label className={styles.contentHeader}>
                    You are about to archive this project. Please confirm to
                    proceed
                  </Label>

                  <Stack horizontal horizontalAlign="end">
                    <PrimaryButton
                      text="Confirm"
                      className={styles.buttonSave}
                      disabled={false}
                      onClick={() => onArchiveProject()}
                    />
                    <PrimaryButton
                      text="Cancel"
                      className={styles.buttonCancel}
                      onClick={hideArchiveModal}
                    />
                  </Stack>
                </Stack>
              </Modal>
              <Modal
                isOpen={isModalReactivateOpen}
                onDismiss={hideReactivateModal}
                isBlocking={false}
                containerClassName={contentStyles.archiveContainer}
              >
                <Stack style={{ padding: 20 }}>
                  <Label className={styles.contentHeader}>
                    You are about to reactivate this project. Please confirm to
                    proceed
                  </Label>

                  <Stack horizontal horizontalAlign="end">
                    <PrimaryButton
                      text="Confirm"
                      className={styles.buttonSave}
                      disabled={false}
                      onClick={() => onReactivateProject()}
                    />
                    <PrimaryButton
                      text="Cancel"
                      className={styles.buttonCancel}
                      onClick={hideReactivateModal}
                    />
                  </Stack>
                </Stack>
              </Modal>
              <Modal
                isOpen={isModalSendTacOrReportOpen}
                onDismiss={hideModalSendTacOrReport}
                isBlocking={false}
                containerClassName={contentStyles.archiveContainer}
              >
                <Stack style={{ padding: 20 }}>
                  {sentReport && (
                    <Label className={styles.contentHeader}>
                      Roland Berger Document Access will (re)send an e-mail with
                      a link to download the report(s)
                    </Label>
                  )}
                  {sentTac && (
                    <Label className={styles.contentHeader}>
                      An e-mail will be{" "}
                      {recipientItem?.sentTermsCondition &&
                      recipientItem?.acceptanceDate == undefined
                        ? "re"
                        : ""}
                      sent to this recipient with an invitation to terms
                      acceptance. Please confirm to proceed
                    </Label>
                  )}
                  <Stack horizontal horizontalAlign="end">
                    <PrimaryButton
                      text="Confirm"
                      className={styles.buttonSave}
                      disabled={false}
                      onClick={() => {
                        sentReport
                          ? onSendNotificationOrReport(recipientItem, true)
                          : onSendNotificationOrReport(recipientItem, false);
                      }}
                    />
                    <PrimaryButton
                      text="Cancel"
                      className={styles.buttonCancel}
                      onClick={hideModalSendTacOrReport}
                    />
                  </Stack>
                </Stack>
              </Modal>
              <Stack>
                <hr className={styles.horizontalLine}></hr>
              </Stack>
              {messageReport != "" && (
                <Stack>
                  <MessageBar
                    messageBarType={messageBarTypeReport}
                    isMultiline={false}
                    dismissButtonAriaLabel="Close"
                    onDismiss={resetMessageReport}
                  >
                    {messageReport}
                  </MessageBar>
                </Stack>
              )}
              {/* <Stack horizontal verticalAlign="center">
                <Label className={styles.contentHeader}>Documents</Label>
              </Stack>

              <Stack horizontal horizontalAlign="start">
                <PrimaryButton
                  text="Browse files"
                  onClick={() => {
                    hiddenFileInput.current.click();
                    hiddenFileInput.current.value = "";
                  }}
                  className={styles.buttonCancel}
                  label="Report"
                  disabled={project.status == "Archived"}
                />

                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={onFileInputChange}
                  accept={".pdf"}
                  style={{ display: "none" }}
                />
              </Stack>
              <Stack>
                <StackItem>
                  <DetailsList
                    items={
                      project.owner?.includes(currentUser?.email)
                        ? reportDocumentManagement
                        : reportDocumentManagement.filter(
                            (x) => x.isDisabled == false
                          )
                    }
                    compact={false}
                    columns={columnsReportDocument}
                    selectionMode={SelectionMode.none}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                  />
                </StackItem>
              </Stack>
              <Stack>
                <hr className={styles.horizontalLine}></hr>
              </Stack> */}
              {messagePermission != "" && (
                <Stack>
                  <MessageBar
                    messageBarType={messageBarTypePermission}
                    isMultiline={false}
                    dismissButtonAriaLabel="Close"
                    onDismiss={resetMessagePermission}
                  >
                    {messagePermission}
                  </MessageBar>
                </Stack>
              )}
              <Stack horizontal horizontalAlign="space-between">
                <Label className={styles.contentHeader}>
                  Internal access management
                </Label>
                {projectId != "" &&
                  project.owner?.includes(currentUser?.email) && (
                    <TooltipHost
                      content="Add user"
                      calloutProps={calloutProps}
                      styles={hostStyles}
                    >
                      <IconButton
                        iconProps={{ iconName: "Add" }}
                        className={styles.btnAddItem}
                        onClick={showModal}
                        disabled={project?.status == "Archived"}
                      ></IconButton>
                    </TooltipHost>
                  )}
                <Modal
                  isOpen={isModalOpen}
                  onDismiss={resetModal}
                  isBlocking={false}
                  containerClassName={
                    deletePermission
                      ? contentStyles.archiveContainer
                      : contentStyles.container
                  }
                >
                  {deletePermission == false && (
                    <Stack style={{ padding: 20 }}>
                      {editPermission &&
                        itemsAccessManagementModal.length > 0 &&
                        currentUser?.email ==
                          itemsAccessManagementModal[0].mail && (
                          <MessageBar messageBarType={MessageBarType.warning}>
                            Only owners can manage user rights. In case you
                            downgrade your user rights, you will not be able to
                            manage user rights
                          </MessageBar>
                        )}
                      <Label className={styles.contentHeader}>
                        Internal access management -{" "}
                        {!editPermission ? "Add user" : "Edit user rights"}
                      </Label>
                      {!editPermission && (
                        <NormalPeoplePicker
                          onChange={onItemsChange}
                          onResolveSuggestions={onFilterChanged}
                          className={"ms-PeoplePicker"}
                          key={"normal"}
                          selectionAriaLabel={"Selected contacts"}
                          removeButtonAriaLabel={"Remove"}
                          resolveDelay={300}
                        />
                      )}

                      <DetailsList
                        items={itemsAccessManagementModal}
                        compact={false}
                        columns={columnsAccessManagementModal}
                        selectionMode={SelectionMode.none}
                        setKey="none"
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                      />
                      <Stack horizontal horizontalAlign="end">
                        <PrimaryButton
                          text={!editPermission ? "Add" : "Edit"}
                          className={styles.buttonSave}
                          disabled={false}
                          onClick={onAddProjectPermission}
                        />
                        <PrimaryButton
                          text="Cancel"
                          className={styles.buttonCancel}
                          onClick={resetModal}
                        />
                      </Stack>
                    </Stack>
                  )}
                  {deletePermission && (
                    <Stack style={{ padding: 20 }}>
                      <Label className={styles.contentHeader}>
                        {currentUser?.email == deletePermissionItem.mail
                          ? `You are about to delete yourself from this project. Please note, that this step cannot be reversed. Please confirm to proceed`
                          : `You are about to delete ${deletePermissionItem.displayName} from this project. Please confirm to proceed`}
                      </Label>

                      <Stack horizontal horizontalAlign="end">
                        <PrimaryButton
                          text="Confirm"
                          className={styles.buttonSave}
                          disabled={false}
                          onClick={() =>
                            onDeleteProjectUserPermission(deletePermissionItem)
                          }
                        />
                        <PrimaryButton
                          text="Cancel"
                          className={styles.buttonCancel}
                          onClick={resetModal}
                        />
                      </Stack>
                    </Stack>
                  )}
                </Modal>
              </Stack>
              <Stack>
                <StackItem>
                  <ShimmeredDetailsList
                    items={itemsAccessManagement.sort(function (a, b) {
                      return a.displayName.localeCompare(b.displayName);
                    })}
                    enableShimmer={isLoadingProject}
                    compact={false}
                    columns={columnsAccessManagement}
                    selectionMode={SelectionMode.none}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                  />
                </StackItem>
              </Stack>
              <Stack>
                <hr className={styles.horizontalLine}></hr>
              </Stack>
              {messageReportDistribution != "" && (
                <Stack style={{ marginBottom: 8 }}>
                  <MessageBar
                    messageBarType={messageBarTypeReportDistribution}
                    isMultiline={false}
                    dismissButtonAriaLabel="Close"
                    onDismiss={resetMessageReportDistribution}
                  >
                    {messageReportDistribution}
                  </MessageBar>
                </Stack>
              )}
              <Stack horizontal horizontalAlign="space-between">
                <Label className={styles.contentHeader}>
                  Report distribution management
                  {/* {projectId != "" &&
                    (project.owner?.includes(currentUser?.email) ||
                      project.contributor?.includes(currentUser?.email)) && (
                      <Stack
                        horizontal
                        horizontalAlign="center"
                        style={{ paddingTop: 12 }}
                      >
                        <TooltipHost
                          content="When checked, the project owner(s) will be bcc'ed in report distribution coordinator invitations"
                          calloutProps={calloutProps}
                          styles={hostStyles}
                        >
                          <Checkbox
                            label="Bcc for report distribution coordinator invitations"
                            checked={!!project?.bccDistributionManagement}
                            onChange={(ev, checked) => {
                              onBccDistributionManagementChanged(checked);
                            }}
                          />
                        </TooltipHost>
                      </Stack>
                    )} */}
                </Label>
                {projectId != "" &&
                  (project.owner?.includes(currentUser?.email) ||
                    project.contributor?.includes(currentUser?.email)) && (
                    <TooltipHost
                      content="Add coordinator"
                      calloutProps={calloutProps}
                      styles={hostStyles}
                    >
                      <IconButton
                        iconProps={{ iconName: "Add" }}
                        className={styles.btnAddItem}
                        onClick={showReportDistributionModal}
                        disabled={project?.status == "Archived"}
                      ></IconButton>
                    </TooltipHost>
                  )}
                <Modal
                  isOpen={isModalReportDistributionOpen}
                  isBlocking={false}
                  containerClassName={
                    deleteCoordinator
                      ? contentStyles.archiveContainer
                      : contentStyles.container
                  }
                  onDismiss={resetModalReportDistribution}
                >
                  {deleteCoordinator && (
                    <Stack style={{ padding: 20 }}>
                      <Label className={styles.contentHeader}>
                        You are about to delete{" "}
                        {deleteCoordinatorItem?.name +
                          " " +
                          deleteCoordinatorItem?.surname}{" "}
                        from this project. Please confirm to proceed
                      </Label>

                      <Stack gap={16} horizontal horizontalAlign="center">
                        <PrimaryButton
                          text="Confirm"
                          className={styles.buttonSave}
                          onClick={() =>
                            onDeleteCoordinator(deleteCoordinatorItem)
                          }
                        />
                        <PrimaryButton
                          text="Cancel"
                          className={styles.buttonCancel}
                          onClick={resetModalReportDistribution}
                        />
                      </Stack>
                    </Stack>
                  )}
                  {!deleteCoordinator && isModalReportDistributionOpen && (
                    <Stack style={{ padding: 20 }}>
                      <Label className={styles.contentHeader}>
                        Report distribution management - Add coordinator
                      </Label>
                      <Stack>
                        <TextField
                          id="email"
                          label="E-mail"
                          type="email"
                          style={{ width: 600, paddingRight: 30 }}
                          errorMessage={errorMessageCoordinatorEmail}
                          onChange={(ev, val) => {
                            onChangeTxtField(ev, "coordinatorEmail", val);
                          }}
                          value={coordinatorEmail}
                        />
                        <TextField
                          id="name"
                          label="First name"
                          style={{ width: 600, paddingRight: 30 }}
                          onChange={(ev, val) => {
                            onChangeTxtField(ev, "coordinatorName", val);
                          }}
                          value={coordinatorName}
                        />
                        <TextField
                          id="surname"
                          label="Last name"
                          style={{ width: 600, paddingRight: 30 }}
                          onChange={(ev, val) => {
                            onChangeTxtField(ev, "coordinatorSurname", val);
                          }}
                          value={coordinatorSurname}
                        />
                        <TextField
                          id="companyName"
                          label="Company"
                          style={{ width: 600, paddingRight: 30 }}
                          onChange={(ev, val) => {
                            onChangeTxtField(ev, "coordinatorCompanyName", val);
                          }}
                          value={coordinatorCompanyName}
                        />
                        <DefaultButton
                          disabled={
                            !coordinatorEmail ||
                            !coordinatorCompanyName ||
                            !coordinatorSurname ||
                            !coordinatorName
                          }
                          iconProps={{ iconName: "Add" }}
                          className={styles.btnAddItem}
                          style={{ width: 200, marginTop: 16 }}
                          onClick={addCoordinator}
                          label="Add coordinator"
                        >
                          Add coordinator
                        </DefaultButton>
                      </Stack>
                      <DetailsList
                        items={reportDistributionModal}
                        compact={false}
                        columns={columnsReportDistributionModal}
                        selectionMode={SelectionMode.none}
                        setKey="none"
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                      />
                      <Stack
                        style={{ marginTop: 16 }}
                        horizontal
                        gap={16}
                        horizontalAlign="end"
                      >
                        <PrimaryButton
                          text="Save"
                          className={styles.buttonSave}
                          disabled={reportDistributionModal.length == 0}
                          onClick={onAddCoordinatorsToManagement}
                        />
                        <PrimaryButton
                          text="Cancel"
                          className={styles.buttonCancel}
                          onClick={resetModalReportDistribution}
                        />
                      </Stack>
                    </Stack>
                  )}
                </Modal>
              </Stack>
              <Stack>
                <StackItem>
                  <ShimmeredDetailsList
                    items={
                      itemsReportDistribution ? itemsReportDistribution : []
                    }
                    enableShimmer={isLoadingProject}
                    compact={false}
                    columns={columnsReportDistributionManagement}
                    selectionMode={SelectionMode.none}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                  />
                </StackItem>
              </Stack>
              <Stack>
                <hr className={styles.horizontalLine}></hr>
              </Stack>
              {messageRecipient != "" && (
                <Stack>
                  <MessageBar
                    messageBarType={messageBarTypeRecipient}
                    isMultiline={false}
                    dismissButtonAriaLabel="Close"
                    onDismiss={resetMessageRecipient}
                  >
                    {messageRecipient}
                  </MessageBar>
                </Stack>
              )}
              <Stack horizontal horizontalAlign="space-between">
                <Label className={styles.contentHeader}>
                  Recipient management
                  {/* {projectId != "" &&
                    (project.owner?.includes(currentUser?.email) ||
                      project.contributor?.includes(currentUser?.email)) && (
                      <Stack
                        horizontal
                        horizontalAlign="center"
                        style={{ paddingTop: 12 }}
                      >
                        <TooltipHost
                          content="When checked,the project owner(s) will be bcc'ed in terms acceptance invitations"
                          calloutProps={calloutProps}
                          styles={hostStyles}
                        >
                          <Checkbox
                            label="Bcc for terms acceptance invitations"
                            checked={!!project?.bccRecipientManagement}
                            onChange={(ev, checked) => {
                              onBccRecipientManagementChanged(checked);
                            }}
                          />
                        </TooltipHost>
                      </Stack>
                    )} */}
                </Label>
                {projectId != "" &&
                  (project.owner?.includes(currentUser?.email) ||
                    project.contributor?.includes(currentUser?.email)) && (
                    <TooltipHost
                      content="Add recipient"
                      calloutProps={calloutProps}
                      styles={hostStyles}
                    >
                      <IconButton
                        iconProps={{ iconName: "Add" }}
                        className={styles.btnAddItem}
                        onClick={showRecipientModal}
                        disabled={project?.status == "Archived"}
                      ></IconButton>
                    </TooltipHost>
                  )}
                <Modal
                  isOpen={isModalRecipientOpen}
                  isBlocking={false}
                  containerClassName={
                    selectAllcheckBoxReport ||
                    selectAllcheckBoxTAC ||
                    deleteRecipient
                      ? contentStyles.archiveContainer
                      : contentStyles.container
                  }
                  onDismiss={resetModalRecipient}
                >
                  {deleteRecipient && (
                    <Stack style={{ padding: 20 }}>
                      <Label className={styles.contentHeader}>
                        You are about to delete {deleteRecipientItem.email} from
                        this project. Please confirm to proceed
                      </Label>

                      <Stack horizontal horizontalAlign="end">
                        <PrimaryButton
                          text="Confirm"
                          className={styles.buttonSave}
                          onClick={() => onDeleteRecipient(deleteRecipientItem)}
                        />
                        <PrimaryButton
                          text="Cancel"
                          className={styles.buttonCancel}
                          onClick={resetModalRecipient}
                        />
                      </Stack>
                    </Stack>
                  )}
                  {!deleteRecipient && (
                    <Stack style={{ padding: 20 }}>
                      {!(selectAllcheckBoxReport || selectAllcheckBoxTAC) && (
                        <Label className={styles.contentHeader}>
                          Recipient management - Add new recipients
                        </Label>
                      )}
                      {(selectAllcheckBoxReport || selectAllcheckBoxTAC) && (
                        <Label className={styles.contentHeader}>
                          {selectAllcheckBoxReport
                            ? "Please note that when selecting this checkbox, all recipients will receive an e-mail with a link to download the report(s) automatically, once the terms and conditions have been accepted. Please confirm to proceed"
                            : "Please note that when selecting this checkbox, all recipients will receive an e-mail with an invitation link to accept the Roland Berger Terms automatically. Please confirm to proceed"}
                        </Label>
                      )}
                      {!(selectAllcheckBoxReport || selectAllcheckBoxTAC) && (
                        <Stack horizontal>
                          <TextField
                            id="Recipient"
                            label=""
                            type="email"
                            style={{ width: 600, paddingRight: 30 }}
                            errorMessage={errorMessageEmail}
                            onChange={(ev, val) => {
                              onChangeTxtField(ev, "email", val);
                            }}
                            value={recipientEmail}
                          />
                          <TooltipHost
                            content="Add recipient"
                            calloutProps={calloutProps}
                            styles={hostStyles}
                          >
                            <IconButton
                              iconProps={{ iconName: "Add" }}
                              className={styles.btnAddItem}
                              onClick={addRecipient}
                              label=""
                            />
                          </TooltipHost>
                        </Stack>
                      )}
                      {!(selectAllcheckBoxReport || selectAllcheckBoxTAC) && (
                        <>
                          <DetailsList
                            items={recipientManagementModal}
                            compact={false}
                            columns={columnsRecipientsManagementModal}
                            selectionMode={SelectionMode.none}
                            setKey="none"
                            layoutMode={DetailsListLayoutMode.justified}
                            isHeaderVisible={true}
                          />
                          <Stack horizontal horizontalAlign="end">
                            <PrimaryButton
                              text="Add"
                              className={styles.buttonSave}
                              disabled={recipientManagementModal.length == 0}
                              onClick={onAddRecipientToManagement}
                            />
                            <PrimaryButton
                              text="Cancel"
                              className={styles.buttonCancel}
                              onClick={resetModalRecipient}
                            />
                          </Stack>
                        </>
                      )}
                      {(selectAllcheckBoxReport || selectAllcheckBoxTAC) && (
                        <Stack horizontal horizontalAlign="end">
                          <PrimaryButton
                            text="Confirm"
                            className={styles.buttonSave}
                            onClick={selectAllCheckBoxes}
                          />
                          <PrimaryButton
                            text="Cancel"
                            className={styles.buttonCancel}
                            onClick={() => {
                              selectAllcheckBoxReport == true
                                ? isCheckedReport(false)
                                : isCheckedTAC(false);
                              resetModalRecipient();
                            }}
                          />
                        </Stack>
                      )}
                    </Stack>
                  )}
                </Modal>
              </Stack>
              <Stack>
                <StackItem>
                  <ShimmeredDetailsList
                    items={
                      itemsRecipientsManagement
                        ? itemsRecipientsManagement.filter((e) => {
                            return e.isDeleted != true;
                          })
                        : []
                    }
                    enableShimmer={isLoadingProject}
                    compact={false}
                    columns={columnsRecipientsManagement}
                    selectionMode={SelectionMode.none}
                    setKey="none"
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                  />
                </StackItem>
              </Stack>
              <Stack horizontal horizontalAlign="end">
                {project?.status == "Draft" && (
                  <PrimaryButton
                    text="Start process"
                    className={styles.buttonNewProject}
                    onClick={showProcessModal}
                    disabled={
                      project.recipients == null ||
                      project.recipients.length == 0 ||
                      project.coordinators == null ||
                      project.coordinators.length == 0
                    }
                  />
                )}
              </Stack>
              <Modal
                isOpen={isModalProcessOpen}
                onDismiss={hideProcessModal}
                isBlocking={false}
                styles={{ main: { minHeight: "unset" } }}
                containerClassName={contentStyles.container}
              >
                <Stack style={{ padding: 20 }}>
                  {numberSelectedRecipients == 0 && (
                    <div className={styles.contentHeader}>
                      Please note that right now no recipients have been
                      selected for the automatic distribution of terms
                      acceptance invitations.
                    </div>
                  )}
                  <div className={styles.contentHeader}>
                    You are about to start the Electronic Release Letter process
                    for
                  </div>
                  <div className={styles.contentHeader}>
                    <Label>
                      "{project?.name} -{" "}
                      {categories.find((c) => c.key === project?.category)
                        ?.text || project?.category}{" "}
                      on {project?.target}"
                    </Label>
                  </div>
                  {/* {numberSelectedRecipients == 0 && (
                    <Label>
                      Please note that right now no recipients have been
                      selected for the automatic sent-out.
                    </Label>
                  )} */}

                  {/* <Stack horizontal horizontalAlign="start">
                    <TextField
                      label="Project name"
                      value={project?.name}
                      readOnly
                      styles={textfieldmodalStyles}
                      borderless
                    />
                    <TextField
                      label="Category"
                      styles={textfieldmodalStyles}
                      value={project?.category}
                      readOnly
                      borderless
                    />
                    <TextField
                      label="Roland Berger entity"
                      styles={textfieldmodalStyles}
                      value={
                        companies.filter((c) => {
                          return c.key == project?.company;
                        }).length > 0
                          ? companies.filter((c) => {
                              return c.key == project?.company;
                            })[0].title
                          : ""
                      }
                      readOnly
                      id="Company"
                      borderless
                    />
                  </Stack>
                  <Stack horizontal horizontalAlign="start">
                    <TextField
                      label="Client"
                      id="Client"
                      value={project?.client}
                      styles={textfieldmodalStyles}
                      readOnly
                      borderless
                    />
                    <TextField
                      label="Target name"
                      id="Target"
                      value={project?.target}
                      styles={textfieldmodalStyles}
                      readOnly
                      borderless
                    />
                  </Stack> */}
                  {numberSelectedRecipients != 0 && (
                    <div className={styles.contentHeader}>
                      Please note that with your confirmation the following
                      recipients will receive invitation links to accept the
                      Roland Berger Terms
                    </div>
                  )}
                  {numberSelectedRecipients != 0 && (
                    <Stack style={{ marginBottom: 10 }}>
                      {itemsRecipientsManagement &&
                        itemsRecipientsManagement.map(
                          (recipient: IRecipientsManagement) =>
                            recipient.autoSendTermsCondition ? (
                              <Label key="recipient.recipientId">
                                {recipient.email}
                              </Label>
                            ) : (
                              ""
                            ),
                        )}
                    </Stack>
                  )}

                  <div className={styles.contentHeader}>
                    Please confirm that this action is aligned with the responsible project Partner(s) and your client.
                  </div>

                  <Stack horizontal horizontalAlign="end">
                    <PrimaryButton
                      text="Confirm"
                      className={styles.buttonSave}
                      disabled={false}
                      onClick={onStartProcess}
                    />
                    <PrimaryButton
                      text="Cancel"
                      className={styles.buttonCancel}
                      onClick={hideProcessModal}
                    />
                  </Stack>
                </Stack>
              </Modal>
            </>
          )}
        </Stack>
      )}
    </>
  );
};
export default NewProject;
